import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import useResizable from '@chronos/ui-toolkit/hooks/useResizable';

import * as S from './styled';
import { ActionText, Title } from '../TransactionItem/styled';

export default function TransactionItemDetails({
  transaction,
  isExpanded,
  onResize,
}) {
  const ref = useRef();
  useResizable(ref, onResize);

  return (
    <S.TransactionDetails
      ref={ref}
      style={{
        display: isExpanded ? 'flex' : 'none',
      }}
    >
      <Title>
        <ActionText>✉️ Email:</ActionText>
        <ActionText bold>{transaction.attributes.data.contactEmail}</ActionText>
      </Title>
      <div>
        <pre>
          ％ VatInfo:
          <code>
            {JSON.stringify(transaction.attributes.data.vatInfo, null, 2)}
          </code>
        </pre>
      </div>
    </S.TransactionDetails>
  );
}

TransactionItemDetails.propTypes = {
  transaction: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool,
  onResize: PropTypes.func,
};

TransactionItemDetails.defaultProps = {
  isExpanded: false,
  onResize: () => {},
};
